/** Prefer the most specific sibling route while keeping detail pages active. */
export function hasMoreSpecificNavigationMatch(
  pathname: string,
  to: string,
  destinations: string[],
) {
  return destinations.some(
    (other) =>
      other !== to &&
      other.startsWith(to + '/') &&
      (pathname === other || pathname.startsWith(other + '/')),
  );
}
